import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from "rxjs";


@Injectable({
    providedIn: 'root'
})
export class PurchaseRequestFormService {

    private _institutionCode: string;
    private prOriginalFields =
        ['resource_metadata.author',
            'resource_metadata.edition',
            'resource_metadata.isbn',
            'resource_metadata.lcc_number',
            'resource_metadata.other_system_number',
            'resource_metadata.publication_place',
            'resource_metadata.publication_year',
            'resource_metadata.publisher',
            'resource_metadata.title',
            'resource_metadata.volume',
            'notes',
            'resource_metadata.requestor_name',
            'resource_metadata.requestor_email',
            'format.value'];


  set institutionCode(institutionCode) {
    this._institutionCode = institutionCode;
  }

  get institutionCode() {
    return this._institutionCode;
  }

  constructor(private httpClient: HttpClient) {
  }

  getPurchaseRequestFormMappingTable(): Observable<any[]> {
    return this.httpClient.get(
      `/almaws/internalRest/general/institutionCode/${this.institutionCode}/rialtoPurchaseRequestForm/fields`) as Observable<any[]>;
  }

  getEmailRegexCustomerParam() : Observable<string>{
    return this.httpClient.get(
      `/almaws/internalRest/general/institutionCode/${this.institutionCode}/purchaseRequestForm/emailRegex`,  { responseType: 'text' });
  }

  getPRFormCustomDetails(){
    return this.httpClient.get(
      `/almaws/internalRest/general/institutionCode/${this.institutionCode}/purchaseRequestForm/customDetails`);
  }

  getPRFormTranslations(labelsToTranslate: any){
    return this.httpClient.post(
      `/almaws/internalRest/general/institutionCode/${this.institutionCode}/rialtoPurchaseRequestForm/formTranslations`, Object.fromEntries(labelsToTranslate));
  }
  addNoteToPR(PRForm, PR, key) {
    if (!PR['note']) {
      PR['note'] = key + ': ' + PRForm[key];
    }
    else {
      PR['note'] = PR['note'] + '\n' + key + ': ' + PRForm[key];
    }
  }

  submitPurchaseRequestForm(PRForm) {
    const PR = {
      resource_metadata: {
        citation_type: {
          value: 'BOOK'
        }
      }
    };
    Object.keys(PRForm).forEach(key => {
      if (PRForm[key] && PRForm[key] !== '') {
        // any field that should be mapped to PR note
        if (this.prOriginalFields.indexOf(key) === -1) {
          this.addNoteToPR(PRForm, PR, key);
        }

        else {
          let keys = key.split('.');
          if (key === 'notes') {
            keys = ['resource_metadata', 'bib_note'];
          }
          keys.reduce((acc, value, idx) => {
            if (idx === keys.length - 1) {
              acc[value] = PRForm[key];
            } else if (!acc[value]) {
              acc[value] = {};
            }
            return acc[value];
          }, PR);
          if (key === 'email') {
            this.addNoteToPR(PRForm, PR, key);
          }
        }
      }
    });

    if (PR['note']) {
      PR['requester_note'] = PR['note'];
      PR['note'] = [{ content: PR['note'] }];
    }

    return this.httpClient.post(
      `/almaws/internalRest/general/institutionCode/${this.institutionCode}/purchaseRequestForm/submit`, PR);

  }
}
